import { useUser } from "@clerk/clerk-react";

export const useFlag = (flag, type = "boolean") => {
  const { user } = useUser();

  if (!user) return false;

  if (type === "literal") {
    return user?.publicMetadata?.flags?.[flag];
  }

  return !!user?.publicMetadata?.flags?.[flag];
};
